import { render, staticRenderFns } from "./MailPreviewModal.vue?vue&type=template&id=181df2f0&"
import script from "./MailPreviewModal.vue?vue&type=script&lang=js&"
export * from "./MailPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports